import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createLifeLineAction = createAsyncThunk(
    'create-lifeline',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/create-update`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createLifeLineSlice = createSlice({
    name: 'create-lifeline',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createLifeLineAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createLifeLineAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createLifeLineAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createLifeLineReducer = createLifeLineSlice.reducer    